import { render, staticRenderFns } from "./OrgFacilitySelect.vue?vue&type=template&id=50fafe64&scoped=true"
import script from "./OrgFacilitySelect.vue?vue&type=script&lang=js"
export * from "./OrgFacilitySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fafe64",
  null
  
)

export default component.exports